module.exports = __webpack_public_path__ + "9b9e57797d2004b6ccc4235da5538498.png";